import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "use-screen-recorder-composition", -1)
const _hoisted_2 = ["src"]

import useScreenRecorder from "use-screen-recorder-composition";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const screenRecorder = useScreenRecorder();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      (['idle', 'permission-requested', 'error'].includes(_unref(screenRecorder).status))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(screenRecorder).actions.startRecording()))
          }, " start recording "))
        : _createCommentVNode("", true),
      (['recording', 'paused'].includes(_unref(screenRecorder).status))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(screenRecorder).actions.stopRecording()))
          }, " stop recording "))
        : _createCommentVNode("", true),
      (['recording', 'paused'].includes(_unref(screenRecorder).status))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(screenRecorder).status === 'paused')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(screenRecorder).actions.resumeRecording()))
                }, " resume recording "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(screenRecorder).actions.pauseRecording()))
                }, " pause recording "))
          ], 64))
        : _createCommentVNode("", true),
      (['stopped'].includes(_unref(screenRecorder).status))
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(screenRecorder).actions.resetRecording()))
          }, " reset recording "))
        : _createCommentVNode("", true)
    ]),
    (_unref(screenRecorder).blobUrl)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          src: _unref(screenRecorder).blobUrl,
          autoplay: "",
          controls: ""
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})